var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"recommend",staticClass:"home"},[(_vm.logoUi.productRecommendUrl)?_c('img',{staticStyle:{"width":"65%","height":"75%"},attrs:{"src":_vm.logoUi.productRecommendUrl,"alt":""}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }